import request from '@core/request'

// 海外-内容管理/新闻列表
export function productNews(data) {
  return request({
    url: '/admin_cms/article/getlist',
    method: 'get',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    data: {
      type: 1,
      rows: data.pageSize,
      page: data.pageNum,
      disabled: false,
    },
  }).then(res => {
    const { rows, total } = res.data
    return {
      ...res,
      data: {
        total,
        list: rows,
      },
    }
  })
}
